import { call, put, select, takeLatest } from 'redux-saga/effects';

import DEALERS_INSIGHTS_API from 'app/dealer/shared/modules/dealersInsights/api/dealersInsights.api';
import { apiCallSaga } from 'app/dealer/shared/modules/dealersInsights/redux/apiCall/sagas';
import {
  selectCurrentDealerId,
  selectCurrentLevel,
  selectCurrentDealer,
} from 'app/dealer/shared/modules/dealersInsights/redux/level/selectors';
import { DEALERS_INSIGHTS_LEVELS } from 'app/dealer/shared/modules/dealersInsights/redux/level/constants';
import { selectNetwork } from 'app/dealer/account/Network/selectors';

import { listingsApiProgressActions } from '../general/actions';
import { selectSelectedListingsBenchmarkTimeDivisionFilter } from '../timeDivision/selectors';
import { selectListingsBenchmarkApiDate } from '../general/selectors';
import { LISTINGS_BENCHMARK_TRACKING } from '../../tracking';

import {
  getListingsBenchmarkTopListingsDataSuccess,
  getListingsBenchmarkTopListingsDataError,
} from './actions';
import {
  selectTopListingsBenchmarkDataByDate,
  selectAllTopListingsBenchmarkDataValuesAreEmpty,
  selectSelectedTopListingsCount,
} from './selectors';
import { ListingsBenchmarkTopListingsActionTypes } from './constants';

export function* getListingsBenchmarkTopListingsDataFetchAsync() {
  const selectedTopListingsCount = yield select(selectSelectedTopListingsCount);

  const timeDivisionFilter = yield select(
    selectSelectedListingsBenchmarkTimeDivisionFilter,
  );

  const selectedApiDate = yield select(selectListingsBenchmarkApiDate);

  const currentDealerId = yield select(selectCurrentDealerId);
  const currentLevel = yield select(selectCurrentLevel);

  const params = {
    size: selectedTopListingsCount,
    tDiv: timeDivisionFilter,
    date: selectedApiDate,
  };

  if (currentLevel === DEALERS_INSIGHTS_LEVELS.DEALER && currentDealerId) {
    params.dealerId = currentDealerId;
  }

  const topListingsApiUrl = yield DEALERS_INSIGHTS_API.topListings(params);
  const { result, error } = yield call(
    apiCallSaga,
    topListingsApiUrl,
    listingsApiProgressActions,
  );

  if (error) {
    yield put(getListingsBenchmarkTopListingsDataError(error));
  } else {
    yield put(
      getListingsBenchmarkTopListingsDataSuccess({
        result,
        currentLevel,
        currentDealerId,
      }),
    );
  }
}

export function* getListingsBenchmarkTopListingsDataAsync() {
  // select any cached top listings data
  const cachedTopListingsDataByDate = yield select(
    selectTopListingsBenchmarkDataByDate,
  );
  const allTopListingsDateEmpty = yield select(
    selectAllTopListingsBenchmarkDataValuesAreEmpty,
  );
  // if there is no cached top listings data then
  // call a GET request to fetch the needed data
  if (!cachedTopListingsDataByDate || allTopListingsDateEmpty) {
    yield call(getListingsBenchmarkTopListingsDataFetchAsync);
  }
}

export function* trackTopListingAction(action) {
  const currentLevel = yield select(selectCurrentLevel);
  const network = yield select(selectNetwork);
  let trackingPayload = {
    network,
    actionType: action.type,
  };

  if (action.category) {
    trackingPayload = {
      ...trackingPayload,
      topListingsCategory: action.category,
    };
  }

  if (currentLevel === DEALERS_INSIGHTS_LEVELS.DEALER) {
    const dealer = yield select(selectCurrentDealer);
    trackingPayload = {
      ...trackingPayload,
      dealer,
    };
    yield call(LISTINGS_BENCHMARK_TRACKING.trackTopListings, trackingPayload);
  } else {
    yield call(LISTINGS_BENCHMARK_TRACKING.trackTopListings, trackingPayload);
  }
}

export function* watchTopListingsTrackingActions() {
  yield takeLatest(
    [
      ListingsBenchmarkTopListingsActionTypes.SET_ACTIVE_TOP_LISTINGS_CATEGORY,
      ListingsBenchmarkTopListingsActionTypes.CLICK_TOP_LISTINGS_CAR_TILE,
      ListingsBenchmarkTopListingsActionTypes.TOGGLE_CATEGORY_DROPDOWN,
    ],
    trackTopListingAction,
  );
}
